// "Send feedback": a short message to us (server/feedback.ts), with an optional email for a reply. The app's
// version, device type, language, screen size and open tab go with it, so problems can be traced. Nothing else:
// no location, no catches, no group data.
import type { FeedbackReport } from "../shared/model.ts";
import { $, $maybe, el, toast } from "./dom.ts";
import { LANG, t } from "./i18n.ts";
import { cancelButton, closeSheet, grow, openSheet, primaryButton } from "./sheet.ts";
import { onRender } from "./state.ts";
import { view } from "./views.ts";
import { account } from "./account.ts";
import { appKind, platform } from "./usage.ts";

export function openFeedback(): void {
  openSheet(t("feedbackTitle"), [
    el("p", { class: "hint", text: t("feedbackIntro") }),
    el("label", { class: "f" }, el("span", { class: "lbl", text: t("feedbackText") }),
      el("textarea", { id: "fb-text", rows: "5", maxlength: "4000", placeholder: t("feedbackTextPh") })),
    el("label", { class: "f" }, el("span", { class: "lbl", text: t("feedbackEmail") }),
      el("input", { type: "email", id: "fb-email", autocomplete: "email", inputmode: "email", placeholder: t("signInEmailPh"), value: account?.email ?? "" })),
    el("p", { class: "hint", text: t("feedbackSent", __APP_BUILD__) }),
  ], [grow(), cancelButton(), primaryButton(t("feedbackSend"), (btn) => void send(btn))]);
  setTimeout(() => $maybe("#fb-text")?.focus(), 50);
}

async function send(btn: HTMLButtonElement): Promise<void> {
  const text = $<HTMLTextAreaElement>("#fb-text").value.trim();
  if (text.length < 2) { $("#fb-text").focus(); return; }
  const report: FeedbackReport = {
    text, email: $<HTMLInputElement>("#fb-email").value.trim(), version: __APP_BUILD__, platform: platform(), app: appKind(), lang: LANG,
    screen: `${Math.round(innerWidth)}x${Math.round(innerHeight)}`, view,
  };
  btn.disabled = true;
  try {
    const res = await fetch("/api/feedback", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(report), signal: AbortSignal.timeout(20000) });
    if (!res.ok) throw new Error(String(res.status));
    closeSheet();
    toast(t("feedbackThanks"));
  } catch { toast(t("feedbackFailed")); btn.disabled = false; }
}

$("#feedback-btn").addEventListener("click", openFeedback);
onRender(() => { $("#app-version").textContent = t("appVersion", __APP_BUILD__); });
